<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/profile'"
            >Profile</router-link
          >
        </li>
      </ol>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        margin-top: 50px;
        flex-direction: column;
      "
    >
      <div
        class="col-8"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          padding-top: 15px;
        "
      >
        <div v-if="!profile_picture" style="text-align: center">
          <media-browser
            filterBy="images"
            v-model="profile_picture"
            :active="showProfileMediaBrowserModal"
            @closeRequest="toggleProfileMediaBrowserModal"
          ></media-browser>
          <i
            @click="toggleProfileMediaBrowserModal"
            style="font-size: 150px"
            class="fa fa-user-circle"
          ></i>
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          "
          v-else
        >
          <div
            style="
              height: 150px;
              width: 150px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <img
              style="border-radius: 50%; width: 100%; height: 100%"
              :src="
                'data:image/' +
                profile_picture.extension +
                ';base64,' +
                profile_picture.image
              "
              alt=""
            />
          </div>
          <div style="margin-top: 15px">
            <button
              style="
                border-radius: 30px;
                padding-top: 0px;
                padding-left: 7px;
                padding-right: 7px;
                padding-bottom: 0px;
              "
              @click="removeProfilePicture()"
              type="button"
              class="btn btn-danger"
            >
              <i style="font-size: 12px" class="fa fa-trash"></i>
              Remove
            </button>
          </div>
        </div>
      </div>
      <div class="col-8" style="display: flex; margin-top: 25px">
        <div class="col-6">
          <label>Title</label>
          <select class="form-control" v-model="title">
            <option
              v-for="title in titleList"
              :key="title.name"
              :value="title.name"
            >
              {{ title.name }}
            </option>
          </select>
        </div>
        <div class="col-6">
          <label>First Name</label>
          <input
            class="form-control"
            type="text"
            required
            v-model="first_name"
          />
        </div>
      </div>
      <div class="col-8" style="display: flex; margin-top: 15px">
        <div class="col-6">
          <label>Last Name</label>
          <input
            class="form-control"
            type="text"
            required
            v-model="last_name"
          />
        </div>
        <div class="col-6">
          <label>Email</label>
          <input class="form-control" type="text" required v-model="email" />
        </div>
      </div>
      <div class="col-8" style="display: flex; margin-top: 15px">
        <div class="col-6">
          <label>Username</label>
          <input class="form-control" type="text" required v-model="username" />
        </div>
        <div class="col-6">
          <label>Password</label>
          <input
            class="form-control"
            type="password"
            required
            v-model="password"
            placeholder="*************"
          />
        </div>
      </div>
      <div class="col-8" style="display: flex; margin-top: 15px">
        <div class="col-12">
          <label>Confirm Password</label>
          <input
            class="form-control"
            type="password"
            required
            v-model="confirm_password"
            placeholder="*************"
          />
        </div>
      </div>
      <div
        class="col-8"
        style="
          display: flex;
          justify-content: end;
          padding-top: 25px;
          padding-bottom: 35px;
        "
      >
        <button type="button" class="btn btn-success" @click="updateUser()">
          Save
        </button>
      </div>
    </div>
  </div>
</template><script>
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
import UserStorer from "../../storers/StoreUser";
import AdministratorStorer from "../../storers/StoreAdministrator";
import MediaBrowser from "../common/MediaBrowser.vue";
export default {
  name: "profile",
  data() {
    return {
      showProfileMediaBrowserModal: false,
      titleList: [{ name: "Mr." }, { name: "Ms." }],
      title: null,
      first_name: null,
      last_name: null,
      profile_picture: null,
      username: null,
      password: null,
      confirm_password: null,
      email: null,
    };
  },
  components: {
    MediaBrowser,
  },
  created: function () {
    this.fillForm();
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      updateUserStatus: (state) => state.userStore.userUpdate.updateUserStatus,
    }),
  },
  methods: {
    fillForm() {
      this.title = this.authUser.userable.title;
      this.first_name = this.authUser.userable.first_name;
      this.last_name = this.authUser.userable.last_name;
      this.username = this.authUser.username;
      this.email = this.authUser.email;
      this.profile_picture = this.authUser.userable.profile_picture;
    },
    removeProfilePicture() {
      this.profile_picture = null;
    },
    formValidation() {
      const result = { isValid: true, message: "" };
      result.message += "Please fill all required fields";
      let missingFieldsString = "";
      if (this.username.length < 5) {
        missingFieldsString += "Username is less than 5 characters ,";
        result.isValid = false;
      }
      if (this.title != "Mr." && this.title != "Ms.") {
        missingFieldsString += "Title prefix is missing, ";
        result.isValid = false;
      }
      if (this.first_name.length < 2) {
        missingFieldsString += "First name is less than 3 characters, ";
        result.isValid = false;
      }
      if (this.last_name.length < 2) {
        missingFieldsString += "Last name is less than 3 characters, ";
        result.isValid = false;
      }
      if (!this.email.trim()) {
        missingFieldsString += "Email, ";
        result.isValid = false;
      }
      if (this.password && this.password.length < 5) {
        missingFieldsString += "Password is less than 5 characters, ";
        result.isValid = false;
      }
      if (this.password != this.confirm_password) {
        missingFieldsString +=
          "Password and Confirmation password are not equal, ";
        result.isValid = false;
      }
      if (missingFieldsString.length > 0) {
        // remove trailing comma
        missingFieldsString = missingFieldsString.substring(
          0,
          missingFieldsString.length - 2
        );
        result.message += ` (${missingFieldsString})`;
      }
      return result;
    },
    updateUser() {
      const { isValid, message } = this.formValidation();
      if (!isValid) {
        sweetAlert({
          title: "Error",
          text: message,
          type: "error",
          confirmButtonText: "Return",
        });
        return;
      }

      var userStorer = UserStorer();
      var administratorStorer = AdministratorStorer();

      userStorer.id = this.authUser.id;
      userStorer.username = this.username;
      userStorer.email = this.email;
      userStorer.password = this.password;
      userStorer.userable_type = this.authUser.userable_type;
      userStorer.userable_id = this.authUser.userable_id;

      administratorStorer.id = this.authUser.userable.id;
      administratorStorer.title = this.title;
      administratorStorer.first_name = this.first_name;
      administratorStorer.last_name = this.last_name;
      if (this.profile_picture) {
        administratorStorer.profile_picture_id = this.profile_picture.id;
      }

      userStorer.userable = administratorStorer;

      this.$store.dispatch("updateUser", {
        userStorer: userStorer,
        is_user_profile: true,
      });
    },
    toggleProfileMediaBrowserModal() {
      this.showProfileMediaBrowserModal = !this.showProfileMediaBrowserModal;
    },
  },
  watch: {
    updateUserStatus() {
      if (this.updateUserStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "User has been updated successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.$router.push("/" + this.authUser.userable_type + "/dashboard");
        });
      } else if (this.updateUserStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "User update has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script> 
 <style>
.md-ripple {
  padding: 0px !important;
}
.table.vgt-table {
  font-size: 20px;
}
.form-control {
  border: 1px solid #ced4da !important;
  background-image: none;
  border-radius: 5px !important;
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/profile.vue